import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAdminLocations = (params) => {
  const query = params?.includeInventory === false ? "?includeInventory=false" : "";
  return fetch(buildUrl(`/api/admin/locations${query}`), {
    credentials: "include",
  }).then(handleResponse);
};

export const createAdminLocation = (payload) =>
  fetch(buildUrl("/api/admin/locations"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const updateAdminLocation = (locationId, payload) =>
  fetch(buildUrl(`/api/admin/locations/${locationId}`), {
    method: "PATCH",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const deleteAdminLocation = (locationId) =>
  fetch(buildUrl(`/api/admin/locations/${locationId}`), {
    method: "DELETE",
    credentials: "include",
  }).then(handleResponse);

export const updateAdminLocationInventory = (locationId, equipmentTypeId, payload) =>
  fetch(buildUrl(`/api/admin/locations/${locationId}/inventory/${equipmentTypeId}`), {
    method: "PATCH",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const createAdminInventoryBlock = (locationId, equipmentTypeId, payload) =>
  fetch(buildUrl(`/api/admin/locations/${locationId}/inventory/${equipmentTypeId}/blocks`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const deleteAdminInventoryBlock = (locationId, equipmentTypeId, blockId) =>
  fetch(
    buildUrl(`/api/admin/locations/${locationId}/inventory/${equipmentTypeId}/blocks/${blockId}`),
    {
      method: "DELETE",
      credentials: "include",
    }
  ).then(handleResponse);

export const resolveAdminLocationMapsLink = (mapUrl) =>
  fetch(buildUrl("/api/admin/locations/resolve-maps"), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify({ mapUrl }),
    credentials: "include",
  }).then(handleResponse);

const adminLocationsApi = {
  getAdminLocations,
  createAdminLocation,
  deleteAdminLocation,
  updateAdminLocation,
  updateAdminLocationInventory,
  createAdminInventoryBlock,
  deleteAdminInventoryBlock,
  resolveAdminLocationMapsLink,
};

export default adminLocationsApi;
